import type { OnPasswordCallback } from 'react-pdf/dist/shared/types.js'

/**
 * Password handler for every <Document> we render.
 *
 * pdf.js asks the host for a password when a file is encrypted. react-pdf answers with
 * window.prompt() by default — a blocking native dialog that reappears for the preview,
 * the thumbnail and the fullscreen viewer, and again on every remount, which makes the
 * whole verification request unworkable (Accept/Reject unreachable).
 *
 * Handing the callback an Error rejects the loading task instead, so <Document> falls
 * through to its `error` node and the rest of the page keeps working.
 */
export const rejectPasswordProtectedPdf = (callback: OnPasswordCallback) => {
  // pdf.js treats an Error as "give up" (see PasswordRequest in pdfjs-dist), but
  // react-pdf's published callback type only covers the string form.
  ;(callback as (password: string | null | Error) => void)(
    new Error('PDF is password-protected'),
  )
}
